import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'digi-text',
  templateUrl: './input-text.component.html',
  styleUrl: './input-text.component.scss'
})
export class InputTextComponent {
  @Input() label: string = '';            // Nhãn của input
  @Input() placeholder: string = '';       // Placeholder của input
  @Input() control!: FormControl;           // FormControl để quản lý giá trị và trạng thái
  @Input() type: string = 'text';          // Kiểu input (mặc định là text)
  @Input() errorMessage: string = '';      // Thông báo lỗi nếu có
  @Output() onFocusInput = new EventEmitter<any>();
  @Input() isSubmit: boolean = false;
  @Input() showSpan: boolean = false; 

  onFocus() {
    this.onFocusInput.emit();
  }
}
